var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDigestive4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.618,
    height: 47,
    viewBox: "0 0 61.618 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7636",
    "data-name": "Group 7636",
    transform: "translate(896.023 -387.885)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4371",
    "data-name": "Path 4371",
    d: "M-816.472,414.317a20.891,20.891,0,0,1-.2-6.187,22.479,22.479,0,0,1,19.276-19.877,62.512,62.512,0,0,1,8.2-.251,1.643,1.643,0,0,1,1.718,1.72c.025,3.526.2,7.063-.7,10.533-2.124,8.2-8.669,15.195-18.212,16.194-1.573.165-3.151.282-4.729.379-.829.051-1.665.009-2.641.009.212-.23.352-.392.5-.543q5.333-5.337,10.666-10.674a1.76,1.76,0,0,0,.059-2.706,1.721,1.721,0,0,0-2.334-.054c-.18.152-.341.325-.507.491q-5.267,5.267-10.527,10.54a2.669,2.669,0,0,0-.348.619Z",
    transform: "translate(-50.768 -0.067)",
    fill: "#aceb1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4372",
    "data-name": "Path 4372",
    d: "M-785.612,480.968v-.84c0-4.389.018-8.778-.019-13.167-.006-.68.195-.906.841-1.019a26.351,26.351,0,0,0,11.338-4.831,8.338,8.338,0,0,0,1.138-.937,1.145,1.145,0,0,1,1.377-.266,10.807,10.807,0,0,1,7.236,11.383,10.842,10.842,0,0,1-9.235,9.547,14.669,14.669,0,0,1-1.853.123c-3.361.012-6.722.006-10.083.006Z",
    transform: "translate(-70.753 -46.089)",
    fill: "#aceb1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4373",
    "data-name": "Path 4373",
    d: "M-834.4,465.593V480c-.195.012-.38.034-.566.034-3.382,0-6.765.018-10.146,0a10.829,10.829,0,0,1-10.668-8.5,10.842,10.842,0,0,1,8.553-12.958c.546-.093,1.1-.149,1.687-.227.193,1.032.33,2.043.576,3.027a5.281,5.281,0,0,0,4.027,4.056,6.893,6.893,0,0,0,1.655.159C-837.683,465.606-836.081,465.593-834.4,465.593Z",
    transform: "translate(-25.617 -45.159)",
    fill: "#aceb1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4374",
    "data-name": "Path 4374",
    d: "M-885.293,445.9l4.781,4.574a14.436,14.436,0,0,0-4.723,10.162,14.4,14.4,0,0,0,4.025,10.638,27.857,27.857,0,0,1-3.017.621,10.757,10.757,0,0,1-11.791-11.051,10.559,10.559,0,0,1,3.138-7.37c2.477-2.518,4.991-5,7.491-7.494C-885.332,445.917-885.261,445.87-885.293,445.9Z",
    transform: "translate(0 -37.176)",
    fill: "#aceb1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4375",
    "data-name": "Path 4375",
    d: "M-823.354,389.934a26.663,26.663,0,0,0-9.5,15.292c-.4-.574-.724-1.008-1.009-1.47a20.644,20.644,0,0,1-3.126-10.766c-.011-1.07-.017-2.141,0-3.211a1.688,1.688,0,0,1,1.657-1.842c4.053-.189,8.041.09,11.791,1.852A1.29,1.29,0,0,1-823.354,389.934Z",
    transform: "translate(-37.831 0)",
    fill: "#aceb1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4376",
    "data-name": "Path 4376",
    d: "M-858.511,429.032l5.411-5.417a24.025,24.025,0,0,0,5.37,8.782c-1.354.331-2.65.645-3.944.969a3.962,3.962,0,0,0-.6.226c-1.171.506-1.171.507-2.1-.424Z",
    transform: "translate(-24.042 -22.9)",
    fill: "#aceb1e"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigestive4);
export default __webpack_public_path__ + "static/media/digestive4.c38ceebcc12f8ddbb78456fa15f13700.svg";
export { ForwardRef as ReactComponent };